module.exports = __webpack_public_path__ + "img/symbol_4.52f7f43c.png";